import { useMode } from "../context/ModeContext";
import { MODES, MODE_META } from "../lib/modes";

// 3-way segmented pill: Junior | Blocks | Python. The active segment is filled with the mode's colour.
// `compact` shrinks it for the navbar (short labels, no icons).
export const ModeToggle = ({ compact = false, testId = "mode-toggle" }) => {
  const { mode, setMode } = useMode();
  const s = compact
    ? { text: "text-xs", icon: "hidden", pad: "px-2.5 py-1", wrap: "p-0.5 gap-0.5" }
    : { text: "text-sm", icon: "w-4 h-4", pad: "px-3 py-1.5", wrap: "p-1 gap-1" };

  return (
    <div
      role="radiogroup"
      aria-label="Coding mode"
      className={`inline-flex items-center ${s.wrap} rounded-full border border-border bg-muted/40 whitespace-nowrap`}
      data-testid={testId}
      data-mode={mode}
    >
      {MODES.map((m) => {
        const meta = MODE_META[m];
        const Icon = meta.icon;
        const active = mode === m;
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setMode(m)}
            title={`Switch to ${meta.label}`}
            className={`inline-flex items-center gap-1.5 rounded-full ${s.pad} ${s.text} font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              active ? `${meta.pill} shadow-sm` : "text-muted-foreground hover:text-foreground"
            }`}
            data-testid={`${testId}-${m}`}
          >
            <Icon className={s.icon} /> {compact ? meta.short : meta.label}
          </button>
        );
      })}
    </div>
  );
};
